export default __webpack_public_path__ + "static/media/waveform_materialisation_voix_anna_20sec.04c8fd42.webm";